<template>
  <div class="myInvitationList">
        <scroller
            :on-infinite="infinite"
            :on-refresh="refresh"
            style="font-size:0.2rem;"
　　         ref="my_scroller"
            refresh-layer-font-size="0.2rem"
            loading-layer-font-size="0.2rem"
            refresh-layer-color="rgba(0,0,0,.36)"
            loading-layer-color="rgba(0,0,0,.36)"
        >
            <div class="top">
                <!-- <div class="look" @click="torankingList" v-if="star=='1'">查看榜单</div> -->
                <div class="centerbox">
                    <p class="fonts1">当前获得奖金</p>
                    <p class="money">
                        <span>{{money}}</span>
                        <span style="font-size:.4rem;">元</span>
                    </p>
                    <p class="getMoney" @click="toGetMoney">提现</p>
                </div>
            </div>
            <div class="listContainer">
                <div class="realList">
                    <div class="zhanwei"   v-show="noServe=='1'">
                        <div>
                            <p>
                            </p>
                            <p style="font-weight:500;color:rgba(0,0,0,1);font-size:0.28rem;">
                                服务器开小差,请稍后重试~
                            </p>
                            <div class="heKnow">
                                <span @click="isFresh">点击重试</span>
                            </div>
                        </div>
                    </div>
                    <div class="zhanwei"   v-show="(invitationList == undefined || invitationList.length <= 0) && noServe=='2'">
                        <div>
                            <p style="font-weight:500;color:rgba(0,0,0,1);font-size:0.28rem;">
                                当前暂无用户～
                            </p>
                        </div>
                    </div>
                    <div class="allList" v-show="invitationList != undefined && invitationList.length > 0">
                        <div class="danList"  v-for="(item,index) in invitationList" :key="index"  v-show="invitationList != undefined && invitationList.length > 0">
                            <div class="imgAndname">
                                <div class="img1">
                                    <img :src="item.avatar" alt="" >
                                </div>
                                <div class="name1">
                                    <p class="name2">{{item.nickname}}</p>
                                    <!-- <p class="created">注册时间 {{item.created | formatDate}}</p> -->
                                    <p class="created" v-if="item.user_status=='0'">已注册未认证</p>
                                    <p class="created" v-if="item.user_status=='1'">新的好友</p>
                                </div>

                            </div>
                            <div class="frend">
                                <p class="inMoney" v-if="item.user_status=='0'">+0元</p>
                                <p class="inMoney" v-if="item.user_status=='1'">+{{item.amount | isAmount}}元</p>
                                <!-- <p class="isFonts">{{item.type | isType}}</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </scroller> 
  </div>
</template>
<script>
import { Loadmore } from 'mint-ui';
import { Toast } from 'mint-ui';
import cbct from '../../assets/js/common/base.js';
import { setTimeout, setInterval, clearInterval } from 'timers';
import md5 from 'js-md5';
import axios from 'axios';
import qs from 'qs';
import share from '../../assets/js/common/share.js';
import shareMsg from '../../assets/js/common/shareConfig.js';
import shareConfig from '../../assets/js/common/shareConfig.js';
export default {
    name: 'myInvitationList',
    data:function(){
        return{
            from1:'',//判断是否来自app
            noDate:false,//重置数据判断
            minHeight:0,
            page:1,
            money:'0',//我的金额
            invitationList:[],//邀请列表
            noServe:'',//判断有无服务
            // star:'0',//是否是主持人 1是0否
        }
    },
    components: {
      
    },
    created(){
        $('title').html("邀请列表");
        let self =this;
        axios.defaults.headers = {
            'Content-Type':'application/x-www-form-urlencoded',
        };
        axios.post(this.cbct.httpslaxin()+'/admin/time', {  
        })
        
        .then(function (response) {
                if(response.data.c == self.cbct.code.successRes){
                    var timing = response.data.d.time - Date.parse(new Date());                
                    self.cbct.setCookie('timing',timing);
                    self.getDate();
                    self.getMoney();
                    self.getPvUv('20204');
                } 
        })
        .catch(function (error) {
        
        });  
        this.from1=this.$route.query.from1;
        if (this.from1=='app') {
            this.getTitle();
            this.isNo();
        }
        var src = this.cbct.https().split('channels.')[1].split('.')[0];
            if(src != ''&& src != undefined){
                if(src != 'dev' && src != 'test'){
                src = '';
                }else{
                src = src+'.';
                }
        }
         var shareUrl='http://channels.h5.'+src+'cbct.cn/newYearVideoPage';
        shareMsg.shareConfig(
            this.from1,'0','0','听见广播 云贺新春','全国电台陪您一起过新年',shareUrl,'http://img001.seefm.com.cn/image/newYearShare.jpg','','0'
        )
    },
    mounted(){
        document.body.style.background="#2D1182";
        $('.myInvitationList').css('min-height',document.documentElement.clientHeight+'px');
        $('.myInvitationList .zhanwei').css('height',document.documentElement.clientHeight-186+'px');
        var self = this; 
        var src = this.cbct.https().split('channels.')[1].split('.')[0];
        if(src != ''&& src != undefined){
            if(src != 'dev' && src != 'test'){
            src = '';
            }else{
            src = src+'.';
            }
        }
        var shareUrl='http://channels.h5.'+src+'cbct.cn/newYearVideoPage';
        share.share(shareUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
        share.QQshare(shareUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
    },
   
    methods:{
        //去提现
        toGetMoney(){
            //提现按钮统计
            this.getPvUv('20206')
            if(this.from1=='app'){
                shareConfig.onAction('app','toWithdrawal','')
            }else{
                this.todownload()
            }
        },
        //去榜单
        torankingList(){
            if(this.from1=='app'){
                this.$router.push('/rankingListNew?from1=app')
            }else{
                this.$router.push('/rankingListNew')
            }
        },
        //数据统计
        getPvUv:function(type){
            let self = this;
            let query = {type}
            self.api.get(this.cbct.httpslaxin()+`/h5/channel/statistics?${qs.stringify(query)}`).then((response)=>{
                if(response.c == this.cbct.code.successRes){ 
                    if(response.d.status == '1'){
                    }
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                   
                }else{

                }
            }
            ).catch((error)=>{console.log(error);})
        },
        // 下拉加载
        infinite(done) {
            let self = this;
            setTimeout(function(){
                if(self.noDate){
                    self.$refs.my_scroller.finishInfinite(2);//这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
                }else{
                    setTimeout(() => {
                        self.page++;//下拉一次页数+1
                        self.getDate();
                        done();//进行下一次加载操作
                    }, 500);
                }
            },200)
        },
        refresh() {
          
            this.page=1;//重置页数刷新每次页数都是第一页
            this.noDate=false;//重置数据判断
            setTimeout(function(){
                this.getDate();
                this.getMoney();
                this.$refs.my_scroller.finishPullToRefresh();//刷新完毕关闭刷新的转圈圈
            }.bind(this),700)
        },
        //声音禁掉
        isNo:function(){
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                const win = window;
                var obj={
                    "action": "onClickPlay",
                    "content": {}
                }
                if (isAndroid) {
                    App.onAppResponse(JSON.stringify(obj));
                }
                if (isIOS) {
                    win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                }  
            },
        //登录处理
        gotoLoginPage:function(){
                var self=this;
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (self.from1 == 'app') {
                        const win = window;
                        var obj={
                            "action": "goToLogin",
                            "content": {
                                'isReturnHomepage':'0'
                            }
                        }
                        if (isAndroid) {
                            App.onAppResponse(JSON.stringify(obj));

                        }
                        if (isIOS) {
                            win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                        }  
                }else{
                    this.$router.push({path:'./fissionLogin'});
                }
            },

     
        //给安卓传title的方法
        getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var obj={
                    "action": "setTitle",
                    "content": {
                        'title':'邀请列表',
                    }
                }
                if (isAndroid){
                    App.onAppResponse(JSON.stringify(obj));
                }
        },
     
        //刷新页面
        isFresh:function(){
            this.$router.go();
        },
        // 奖金
        getMoney:function(){
            let self = this;
            self.api2.post(this.cbct.httpslaxin()+'/h5/fission/my-amount').then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                   this.money= (Number(response.d.money)/100).toFixed(2)
                //    this.star = response.d.star
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    this.noServe='1';
                    this.noDate = true;
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                    //  self.gotoLoginPage();
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    this.noServe='1';
                    this.noDate = true;
                }
            }
            ).catch((error)=>{console.log(error);})
        },

         // 获取邀请列表
        getDate:function(){
            let self = this;
            self.api2.post(this.cbct.httpslaxin()+'/h5/fission/my-invite-list', this.qs.stringify({
                page:this.page,
                pageSize:'8',
            })).then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                    this.$refs.my_scroller.finishPullToRefresh();
                    let d=response.d;
                    var length=0;
                    this.noServe='2';
                    if (response.d.length==length) {
                        this.noDate = true;
                    }else if(this.page==1){
                        this.invitationList=response.d;
                    }else{
                        let invitationList1=response.d;
                        this.invitationList=this.invitationList.concat(invitationList1);
                    }

                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    this.noServe='1';
                    this.noDate = true;
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                    this.noDate = true;
                    // self.gotoLoginPage();
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    this.noServe='1';
                    this.noDate = true;
                }
            }
            ).catch((error)=>{console.log(error);})
        },
        todownload(){
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                var ua = navigator.userAgent.split("(")[1].split(")")[0];
                // alert(ua);
                var phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
                if (phone[1].test(ua)) {
                    window.location.href='https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100594819?source=appshare&subsource=C100594819';
                } else if (phone[2].test(ua)) {
                    window.location.href='http://app.xiaomi.com/detail/760715';
                } else if (phone[3].test(ua)) {
                    window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
                } else if (phone[4].test(ua)) {
                    window.location.href='http://appdetailh5.vivo.com.cn/detail/2418329?source=7';
                } else {
                    var uas = navigator.userAgent.toLowerCase();
                    if(uas.match(/MicroMessenger/i)=="micromessenger") {
                    window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.cbct.seefm';
                    }else{
                        window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.cbct.seefm';
                    }
                }
            }
            if (isIOS) {
                window.location.href='https://itunes.apple.com/cn/app/%E5%90%AC%E8%A7%81%E5%B9%BF%E6%92%AD-%E5%8F%AF%E5%90%AC%E5%8F%AF%E7%9C%8B%E7%9A%84%E5%B9%BF%E6%92%AD%E7%94%B5%E5%8F%B0%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD/id1439524045?mt=8';
            }
        },
    },
    destroyed(){
    },
    filters:{
        // 转换时间
        formatDate(time) {
            var date = new Date(time*1000);
            return cbct.formatDate(date, 'yyyy-MM-dd');
        },
        isType(type){
            var types;
            if (type=='second_user') {
                types='一级好友'
            }else if(type=='third_user'){
                types="二级好友"
            }
            return types;

        },
        isAmount(amount){
            return (Number(amount)/100)
        }
    },
    
}
</script>
<style>
._v-container>._v-content>.loading-layer>.no-data-text{
    font-size: 0.26rem;
}

</style>
<style scoped lang="scss">
    .myInvitationList{
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        overflow: hidden;
        touch-action: pan-y;
        font-size: 0.2rem;
        
        .top{
            position: relative;
            width: 100%;
            box-sizing: border-box;
            margin: auto;
            height: 2.3rem;
            background:url("../../assets/img/wuhanImg/invitationBg1.png") 0 0% no-repeat;
            background-size:100% 100%;
            text-align: center;
            // padding: 0.7rem 0 0;
            .look{
                position: absolute;
                right:0;
                top:0.18rem;
                padding:0.12rem 0.18rem 0.12rem 0.26rem;
                background: rgba(255,255,255,.82);
                border-radius: 0.12rem 0 0 .12rem;
                font-weight:500;
                color:rgba(154,76,5,1);
                font-size: 0.26rem;

                img{
                    width: 1.7rem;
                    height: 0.6rem;
                }
            }
            .centerbox{
                position: absolute;
                top:.6rem;
                width:7.5rem;
                height:3.84rem;
                background: url('../../assets/img/wuhanImg/getmoneyBox.png') no-repeat;
                background-size:100% 100%;
                border-radius:0.16rem;
                .fonts1{
                    font-size:0.3rem;
                    font-weight:400;
                    color:rgba(154,76,5,1);
                    margin-top: .6rem;
                }
                .money{
                    font-size:1rem;
                    font-weight:bold;
                    color:rgba(154,76,5,1);
                    // margin-top: 0.24rem;
                    // margin-bottom: 0.4rem;
                }
                .getMoney{
                    display: inline-block;
                    width:5.32rem;
                    height:0.8rem;
                    background:rgba(251,255,255,1);
                    box-shadow:0px 0.12rem 0.24rem 0px rgba(255,212,141,1);
                    border-radius:0.4rem;
                    font-size:0.32rem;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:bold;
                    color:rgba(211,147,70,1);
                    text-align: center;
                    line-height: 0.8rem;
                }
            }
            
        }
        .listContainer{
            flex: 1;
            width: 100%;
            box-sizing: border-box;
            padding: 0 0.36rem;
            padding-top: 2.16rem;
            // margin-top: 0.42rem;
            .realList{
                flex: 1;
                width: 100%;
                box-sizing: border-box;
                // background:rgba(132,98,244,0.57);
                border-radius:0.08rem; 
                .zhanwei{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.24rem;
                    .heKnow{
                        span{
                            display: inline-block;
                            width: 2.36rem;
                            height: 0.68rem;
                            line-height: 0.68rem;
                            border-radius: 0.59rem;
                            border:solid 1px rgba(255,255,255,1);
                            color: white;
                            margin-top: 0.3rem;
                       }
                    }
                }
                .allList{
                    width: 100%;
                    box-sizing: border-box;
                    // padding: 0.22rem 0.24rem 0 0.26rem;
                    .danList{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        // height: 1.5rem;
                        padding: .24rem 0 .3rem 0;
                        border-bottom: solid 1px rgba(0, 0, 0, .1);
                        justify-content: space-between;
                        .imgAndname{
                           display: flex;
                           align-items: center; 
                           .img1{
                               width: 0.88rem;
                               height: 0.88rem;
                            //    border: solid 1px;
                               margin-right: 0.3rem;
                            //    border-radius:0.08rem;
                               img{
                                   width: 100%;
                                   height: 100%;

                               }
                           }
                           .name1{
                               text-align: left;
                              .name2{
                                    width: 2.68rem;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                    font-size:0.28rem;
                                    font-weight:500;
                                    // padding-top: 0.08rem;
                                    color:rgba(0,0,0,1);
                                    margin-bottom: 0.08rem;
                                    line-height:0.4rem;

                               }
                               .created{
                                    font-size:0.22rem;
                                    font-weight:400;
                                    color:rgba(0,0,0,.7);
                               }
                           }
                        }
                        .frend{
                            font-size:0.22rem;
                            font-weight:400;
                            text-align: right;
                            .isFonts{
                                color:rgba(0,0,0,1);
                                margin-top: 0.08rem;
                            }
                            .inMoney{
                               color:rgba(242,73,73,1);
                               font-weight: 600;
                            }
                            

                        }

                    }
                    .danList:last-of-type{
                       border: none;
                    }

                }
                ::-webkit-scrollbar{display: none;}
            }

        }
    }
</style>
